import { ColDef, ProcessCellForExportParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { CellRendererSubscribedComponent } from '../../../shared-components/grid-cell-renderers/cell-renderer-subscribed/cell-renderer-subscribed.component';

const valueGetter = (params: ValueFormatterParams | ValueGetterParams | ProcessCellForExportParams) =>
  params?.node?.data?.restricted ? 'Not subscribed' : 'Subscribed';

export const DEFAULT_RESTRICTED_COL_DEF: ColDef = {
  headerName: 'Index',
  field: 'restricted',
  valueGetter,
  filterValueGetter: valueGetter,
  cellRenderer: CellRendererSubscribedComponent,
};
